const STORAGE_KEY = 'deepsage-invite-code';
const LEGACY_STORAGE_KEY = 'privy-invite-code';

function readStoredInviteCode() {
  if (typeof sessionStorage === 'undefined') return '';
  const primary = String(sessionStorage.getItem(STORAGE_KEY) ?? '').trim();
  if (primary) return primary;
  return String(sessionStorage.getItem(LEGACY_STORAGE_KEY) ?? '').trim();
}

function clearStoredInviteCode() {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(LEGACY_STORAGE_KEY);
}

/** 持久化邀请码（推荐链接 ?invite= 或登录前手动输入） */
export function storeInviteCode(code) {
  if (typeof sessionStorage === 'undefined') return;
  const value = String(code ?? '').trim();
  if (!value) {
    clearStoredInviteCode();
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, value);
  sessionStorage.setItem(LEGACY_STORAGE_KEY, value);
}

/** 读取邀请码，不消费 */
export function getInviteCode() {
  return readStoredInviteCode();
}

/** 读取并清除邀请码（登录成功后调用） */
export function consumeInviteCode() {
  const code = readStoredInviteCode();
  clearStoredInviteCode();
  return code;
}

/** 从路由 query 解析 invite（兼容旧 inviteCode）并写入 sessionStorage */
export function captureInviteCodeFromRouteQuery(query) {
  const raw = query?.invite ?? query?.inviteCode;
  const value = Array.isArray(raw) ? raw[0] : raw;
  const code = String(value ?? '').trim();
  if (code) storeInviteCode(code);
  return code;
}

/** 生成去掉 invite / inviteCode 的 query（用于 URL 清理） */
export function stripInviteCodeFromQuery(query) {
  if (!query) return null;
  const hasInvite = query.invite != null && query.invite !== '';
  const hasLegacy = query.inviteCode != null && query.inviteCode !== '';
  if (!hasInvite && !hasLegacy) return null;
  const next = { ...query };
  delete next.invite;
  delete next.inviteCode;
  return next;
}
